module.exports = __webpack_public_path__ + "static/media/git.bef8eca1.png";